import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import { initAuth } from './api/initAuth';

const root = ReactDOM.createRoot(document.getElementById('root'));

const startApp = async () => {
  await initAuth();

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
